import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type IAddress = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type IAllocation = {
  amount: Scalars['Float']['input'];
  orderItemId: Scalars['Float']['input'];
};

export enum IApplicableItemType {
  Course = 'COURSE',
  Coursesession = 'COURSESESSION',
  Exam = 'EXAM'
}

export type IAttendance = {
  __typename?: 'Attendance';
  courseSession: ICourseSession;
  id: Scalars['ID']['output'];
  user: IUser;
};

export type IAttendanceDownloadCourse = {
  __typename?: 'AttendanceDownloadCourse';
  attendanceTypes: Array<IAttendanceType>;
  courseId: Scalars['Float']['output'];
  courseName: Scalars['String']['output'];
  sessions: Array<IAttendanceDownloadSession>;
  students: Array<IAttendanceDownloadStudent>;
};

export type IAttendanceDownloadSession = {
  __typename?: 'AttendanceDownloadSession';
  id: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type IAttendanceDownloadStudent = {
  __typename?: 'AttendanceDownloadStudent';
  attendance: Array<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  studentId: Scalars['Float']['output'];
  studentName: Scalars['String']['output'];
};

export type IAttendanceMatrix = {
  __typename?: 'AttendanceMatrix';
  attended: Scalars['Boolean']['output'];
  canAttend: Scalars['Boolean']['output'];
  sessionId: Scalars['Float']['output'];
};

export type IAttendanceMatrixResponse = {
  __typename?: 'AttendanceMatrixResponse';
  attendanceMatrix?: Maybe<Array<IStudentAttendanceMatrix>>;
  errors?: Maybe<Array<IFieldError>>;
};

/** Age groups or category of people attending */
export enum IAttendanceType {
  Adults = 'ADULTS',
  Children = 'CHILDREN'
}

export type IBasket = {
  __typename?: 'Basket';
  /** The basket-level promo code applied, if any */
  appliedBasketPromoCode?: Maybe<IPromoCode>;
  chargeTotal?: Maybe<Scalars['Int']['output']>;
  creditItems?: Maybe<Array<ICreditItem>>;
  creditTotal?: Maybe<Scalars['Int']['output']>;
  discountTotal?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  feeItems?: Maybe<Array<IFeeItem>>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<ILineItem>>;
  orderModifiers?: Maybe<Array<IOrderModifier>>;
  payLater?: Maybe<Scalars['Int']['output']>;
  /** Total discount from applied BASKET promo code */
  promoCodeDiscountValue?: Maybe<Scalars['Float']['output']>;
  siteId?: Maybe<ISiteId>;
  subTotal: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  useCredit?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<IUser>;
};

export type IBasketResponse = {
  __typename?: 'BasketResponse';
  basket?: Maybe<IBasket>;
  errors?: Maybe<Array<IFieldError>>;
};

export type IBookingReportResponse = {
  __typename?: 'BookingReportResponse';
  bookings?: Maybe<Array<IBookingResponse>>;
};

export type IBookingResponse = {
  __typename?: 'BookingResponse';
  courseId?: Maybe<Scalars['Float']['output']>;
  courseType?: Maybe<ICourseTypes>;
  date?: Maybe<Scalars['DateTime']['output']>;
  debug?: Maybe<Scalars['String']['output']>;
  fullBookings?: Maybe<Scalars['Float']['output']>;
  tasterBookings?: Maybe<Scalars['Float']['output']>;
  week?: Maybe<Scalars['Float']['output']>;
  weekStarting?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type ICheckoutCostumeInput = {
  costumeId: Scalars['Int']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  toUserId: Scalars['Int']['input'];
};

export type ICheckoutItemInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toUserId: Scalars['Int']['input'];
};

export type IClassHoliday = {
  __typename?: 'ClassHoliday';
  endDateTime: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  sites?: Maybe<Array<ISiteId>>;
  startDateTime: Scalars['DateTime']['output'];
  term?: Maybe<ITerm>;
};

export type ICourse = IICourse & {
  __typename?: 'Course';
  active?: Maybe<Scalars['Boolean']['output']>;
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  attendanceTypes: Array<IAttendanceType>;
  availableSpaces?: Maybe<Scalars['Int']['output']>;
  courseGroup?: Maybe<ICourseGroup>;
  currentPrice?: Maybe<Scalars['Int']['output']>;
  danceType?: Maybe<IDanceTypeEnum>;
  days?: Maybe<Scalars['String']['output']>;
  depositEnd?: Maybe<Scalars['DateTime']['output']>;
  depositPrice?: Maybe<Scalars['Int']['output']>;
  depositStart?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<IDisplayStatus>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  exams?: Maybe<Array<IExam>>;
  fullyBooked?: Maybe<Scalars['Boolean']['output']>;
  futureCourseSessions?: Maybe<Array<ICourseSession>>;
  hasTasterClasses?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imagePosition?: Maybe<IPosition>;
  isAcceptingDeposits?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<ILevel>;
  lineItems?: Maybe<ILineItem>;
  listStyle?: Maybe<ICourseListStyle>;
  location?: Maybe<ILocationEnum>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<INote>>;
  order?: Maybe<Scalars['Float']['output']>;
  orderItems?: Maybe<Array<IOrderItem>>;
  originalPrice?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  reducePriceOverTime?: Maybe<Scalars['Boolean']['output']>;
  scheduleData?: Maybe<IScheduleData>;
  sessions?: Maybe<Array<ICourseSession>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<ISiteId>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tasterPrice?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<IUser>;
  teachers?: Maybe<Array<IUser>>;
  term?: Maybe<ITerm>;
  termId?: Maybe<Scalars['Int']['output']>;
  thumbImage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<IUser>>;
  videos?: Maybe<Array<IVideo>>;
  weeks?: Maybe<Scalars['String']['output']>;
};

export type ICourseAttendanceCount = {
  __typename?: 'CourseAttendanceCount';
  attendeeCount: Scalars['Float']['output'];
  courseId: Scalars['Float']['output'];
  courseSessionId: Scalars['Float']['output'];
};

export type ICourseBookingsCount = {
  __typename?: 'CourseBookingsCount';
  courseAttendanceType?: Maybe<Scalars['String']['output']>;
  courseId: Scalars['Float']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  courseType?: Maybe<Scalars['String']['output']>;
  fullBookings: Scalars['Float']['output'];
  pendingBookings: Scalars['Float']['output'];
  tasterBookings: Scalars['Float']['output'];
  termId?: Maybe<Scalars['Float']['output']>;
  totalFullBookings: Scalars['Float']['output'];
  totalPendingBookings: Scalars['Float']['output'];
  totalTasterBookings: Scalars['Float']['output'];
  week: Scalars['Float']['output'];
  weekStarting: Scalars['DateTime']['output'];
  year: Scalars['Float']['output'];
};

export type ICourseGroup = {
  __typename?: 'CourseGroup';
  active?: Maybe<Scalars['Boolean']['output']>;
  attendanceTypes?: Maybe<Array<IAttendanceType>>;
  courseTypes?: Maybe<Array<Scalars['String']['output']>>;
  courses?: Maybe<Array<ICourseResult>>;
  danceType?: Maybe<IDanceTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<IDisplayStatus>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imagePosition?: Maybe<IPosition>;
  locations?: Maybe<Array<ILocationEnum>>;
  maxOriginalPrice?: Maybe<Scalars['Float']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  minOriginalPrice?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<ISiteId>;
  thumbImage?: Maybe<Scalars['String']['output']>;
};

export type ICourseInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  ageFrom?: InputMaybe<Scalars['Float']['input']>;
  ageTo?: InputMaybe<Scalars['Float']['input']>;
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<ILevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ICourseListStyle {
  Sessions = 'SESSIONS',
  Summary = 'SUMMARY'
}

export type ICourseOrderSummary = {
  __typename?: 'CourseOrderSummary';
  courseId: Scalars['Float']['output'];
  income: Scalars['Float']['output'];
  isChildCourse: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  missingOrders: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  orderCount: Scalars['Float']['output'];
  siteId: Scalars['String']['output'];
  students: Scalars['Float']['output'];
  totalHours: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type ICoursePaymentMethod = {
  __typename?: 'CoursePaymentMethod';
  courseId: Scalars['Float']['output'];
  courseName: Scalars['String']['output'];
  income: Scalars['Float']['output'];
  paymentMethod: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ICourseResponse = {
  __typename?: 'CourseResponse';
  courseGroups?: Maybe<Array<ICourseGroup>>;
  courseSessions?: Maybe<Array<ICourseSession>>;
  courses?: Maybe<Array<ICourseResult>>;
  errors?: Maybe<Array<IFieldError>>;
  success: Scalars['Boolean']['output'];
};

export type ICourseResult = IOnlineCourse | IStudioCourse;

export type ICourseSearchInput = {
  attendanceTypes?: InputMaybe<IAttendanceType>;
  courseType?: InputMaybe<Scalars['String']['input']>;
  danceType?: InputMaybe<Scalars['String']['input']>;
  displayStatus?: InputMaybe<IDisplayStatus>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  termId?: InputMaybe<Scalars['Float']['input']>;
};

export type ICourseSession = {
  __typename?: 'CourseSession';
  attendance?: Maybe<IAttendance>;
  course?: Maybe<ICourseResult>;
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  lineItems?: Maybe<ILineItem>;
  meetingId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  purchasedCourse?: Maybe<Scalars['Boolean']['output']>;
  startDateTime: Scalars['DateTime']['output'];
  users?: Maybe<Array<IUser>>;
};

export type ICourseSessionSummary = {
  __typename?: 'CourseSessionSummary';
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  startDateTime: Scalars['DateTime']['output'];
};

export type ICourseSummary = {
  __typename?: 'CourseSummary';
  displayStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ICourseTypeSummary = {
  __typename?: 'CourseTypeSummary';
  catsFull: Scalars['Float']['output'];
  catsTaster: Scalars['Float']['output'];
  courseType: Scalars['String']['output'];
  ukcpaFull: Scalars['Float']['output'];
  ukcpaTaster: Scalars['Float']['output'];
};

/** Types of courses available */
export enum ICourseTypes {
  Online = 'ONLINE',
  Studio = 'STUDIO'
}

export type ICourseVideoInput = {
  courseId?: InputMaybe<Scalars['Float']['input']>;
};

export type ICreateOrderStripeInvoiceInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  daysUntilDue?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};

export type ICreatePaymentInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Float']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: IPaymentMethodType;
};

export type ICreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  heardAboutUs?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  weChatId: Scalars['String']['input'];
};

export type ICreditItem = {
  __typename?: 'CreditItem';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ICreditItemStatus>;
  type?: Maybe<ICreditItemType>;
  value: Scalars['Int']['output'];
};

export enum ICreditItemStatus {
  New = 'NEW',
  Refunded = 'REFUNDED',
  Used = 'USED'
}

export enum ICreditItemType {
  Taster = 'TASTER',
  User = 'USER'
}

export type ICreditUsage = {
  __typename?: 'CreditUsage';
  catsFull: Scalars['Float']['output'];
  catsTaster: Scalars['Float']['output'];
  ukcpaFull: Scalars['Float']['output'];
  ukcpaTaster: Scalars['Float']['output'];
};

/** Different dance types */
export enum IDanceTypeEnum {
  Ballet = 'BALLET',
  Belly = 'BELLY',
  Chinese = 'CHINESE',
  Hiphop = 'HIPHOP',
  Jazz = 'JAZZ',
  Kpop = 'KPOP',
  Latin = 'LATIN'
}

export type IDefaultResponse = {
  __typename?: 'DefaultResponse';
  errors?: Maybe<Array<IFieldError>>;
  success: Scalars['Boolean']['output'];
};

export type IDiagnosticQueryArgument = {
  __typename?: 'DiagnosticQueryArgument';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type IDiagnosticQueryDescriptor = {
  __typename?: 'DiagnosticQueryDescriptor';
  arguments: Array<IDiagnosticQueryArgument>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  returnType: Scalars['String']['output'];
  sampleQuery: Scalars['String']['output'];
};

export enum IDisplayStatus {
  Draft = 'DRAFT',
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type IDoubleChargeCandidate = {
  __typename?: 'DoubleChargeCandidate';
  courseId: Scalars['Int']['output'];
  createdAtA: Scalars['DateTime']['output'];
  createdAtB: Scalars['DateTime']['output'];
  orderAId: Scalars['Int']['output'];
  orderAStatus: Scalars['String']['output'];
  orderATotal: Scalars['Int']['output'];
  orderBId: Scalars['Int']['output'];
  orderBStatus: Scalars['String']['output'];
  orderBTotal: Scalars['Int']['output'];
  secondsBetween: Scalars['Int']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type IEtb = {
  __typename?: 'ETB';
  eventId?: Maybe<Scalars['Float']['output']>;
  seatCount?: Maybe<Scalars['Float']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type IEnrolmentDiagnostic = {
  __typename?: 'EnrolmentDiagnostic';
  course?: Maybe<ICourseSummary>;
  courseId: Scalars['Int']['output'];
  courseSessions: Array<ICourseSessionSummary>;
  enrolment?: Maybe<IEnrolmentRow>;
  isEnrolled: Scalars['Boolean']['output'];
  linkedOrders: Array<IEnrolmentOrderRef>;
  userId: Scalars['Int']['output'];
};

export type IEnrolmentLink = {
  __typename?: 'EnrolmentLink';
  courseId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type IEnrolmentOrderRef = {
  __typename?: 'EnrolmentOrderRef';
  courseSessionId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  orderItemCompleted: Scalars['Boolean']['output'];
  orderItemId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type IEnrolmentRow = {
  __typename?: 'EnrolmentRow';
  courseId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type IEvent = {
  __typename?: 'Event';
  address: IAddress;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<IDisplayStatus>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  portraitImage?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  tiers: Array<IEventTier>;
};

export type IEventResponse = {
  __typename?: 'EventResponse';
  event?: Maybe<IEvent>;
  events?: Maybe<Array<IEvent>>;
};

export type IEventSearchInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IEventSeat = {
  __typename?: 'EventSeat';
  id?: Maybe<Scalars['ID']['output']>;
  lineItems?: Maybe<ILineItem>;
  name?: Maybe<Scalars['String']['output']>;
  orderItems?: Maybe<IOrderItem>;
  tier: IEventTier;
  user?: Maybe<IUser>;
};

export type IEventSummaryInput = {
  eventId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type IEventSummaryResponse = {
  __typename?: 'EventSummaryResponse';
  errors?: Maybe<Array<IFieldError>>;
  event?: Maybe<IUserEventSummary>;
  events?: Maybe<Array<IUserEventSummary>>;
};

export type IEventTier = {
  __typename?: 'EventTier';
  availableSpaces?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<IEvent>;
  id?: Maybe<Scalars['Float']['output']>;
  maxSpaces?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  seats?: Maybe<IEventSeat>;
  showSeats?: Maybe<Scalars['Boolean']['output']>;
};

export type IExam = {
  __typename?: 'Exam';
  active?: Maybe<Scalars['Boolean']['output']>;
  address: IAddress;
  attendanceType: IAttendanceType;
  course?: Maybe<ICourse>;
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  examGroup?: Maybe<IExamGroup>;
  id: Scalars['Float']['output'];
  lineItems?: Maybe<ILineItem>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<IUser>>;
};

export type IExamGroup = {
  __typename?: 'ExamGroup';
  exams?: Maybe<Array<IExam>>;
  id?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type IExtraChildInfo = {
  __typename?: 'ExtraChildInfo';
  allergies?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lineItemId?: Maybe<Scalars['String']['output']>;
  medicalConditions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IExtraPaymentEntry = {
  __typename?: 'ExtraPaymentEntry';
  amount: Scalars['Float']['output'];
  bookingType: Scalars['String']['output'];
  courseId: Scalars['Float']['output'];
  courseName: Scalars['String']['output'];
  orderId: Scalars['Float']['output'];
  orderItemId: Scalars['Float']['output'];
  payerEmail?: Maybe<Scalars['String']['output']>;
  payerId: Scalars['Float']['output'];
  payerName: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
};

export type IFeeItem = {
  __typename?: 'FeeItem';
  basket?: Maybe<IBasket>;
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  value: Scalars['Float']['output'];
};

export type IFieldError = {
  __typename?: 'FieldError';
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type IFixEventBookingsResponse = {
  __typename?: 'FixEventBookingsResponse';
  seats: Scalars['Int']['output'];
};

export type IFixPaymentsInput = {
  orderId: Scalars['Float']['input'];
  /** Payment transaction to allocate. If null, use resetAllocations to reset payment transactions */
  paymentTransactionId?: InputMaybe<Scalars['Float']['input']>;
};

export type IHealthCheckResultType = {
  __typename?: 'HealthCheckResultType';
  checkName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  failureCount: Scalars['Int']['output'];
  lastRunAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

/** Where a user heard about us */
export enum IHeardAboutUs {
  Facebook = 'FACEBOOK',
  Friend = 'FRIEND',
  Google = 'GOOGLE',
  Other = 'OTHER',
  Wechat = 'WECHAT'
}

export type IICourse = {
  active?: Maybe<Scalars['Boolean']['output']>;
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<ILevel>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type IIntakeItemInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toLocationId: Scalars['Int']['input'];
};

export type IInventoryCostume = {
  __typename?: 'InventoryCostume';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IInventoryImage>>;
  items?: Maybe<Array<IInventoryItem>>;
  name: Scalars['String']['output'];
};

export type IInventoryCostumeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Whether an item is currently held by a location or a person */
export enum IInventoryHolderType {
  Location = 'LOCATION',
  User = 'USER'
}

export type IInventoryIdInput = {
  id: Scalars['Int']['input'];
};

export type IInventoryIdentifyInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type IInventoryImage = {
  __typename?: 'InventoryImage';
  caption?: Maybe<Scalars['String']['output']>;
  costume?: Maybe<IInventoryCostume>;
  id: Scalars['ID']['output'];
  item?: Maybe<IInventoryItem>;
  location?: Maybe<IInventoryLocation>;
  movement?: Maybe<IInventoryMovement>;
  type: IInventoryImageType;
  uploadedBy?: Maybe<IUser>;
  url: Scalars['String']['output'];
};

/** Category of an inventory image (general, location, or damage evidence) */
export enum IInventoryImageType {
  Damage = 'DAMAGE',
  General = 'GENERAL',
  Location = 'LOCATION'
}

export type IInventoryItem = {
  __typename?: 'InventoryItem';
  assetTag?: Maybe<Scalars['String']['output']>;
  costume?: Maybe<IInventoryCostume>;
  costumeId?: Maybe<Scalars['ID']['output']>;
  currentHolderUser?: Maybe<IUser>;
  currentHolderUserId?: Maybe<Scalars['ID']['output']>;
  currentLocation?: Maybe<IInventoryLocation>;
  currentLocationId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  holderType?: Maybe<IInventoryHolderType>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IInventoryImage>>;
  movements?: Maybe<Array<IInventoryMovement>>;
  name: Scalars['String']['output'];
  status: IInventoryItemStatus;
};

export type IInventoryItemInput = {
  assetTag?: InputMaybe<Scalars['String']['input']>;
  costumeId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<IInventoryItemStatus>;
};

/** Lifecycle status of a physical inventory item */
export enum IInventoryItemStatus {
  Available = 'AVAILABLE',
  CheckedOut = 'CHECKED_OUT',
  InRepair = 'IN_REPAIR',
  Lost = 'LOST',
  Retired = 'RETIRED'
}

export type IInventoryLocation = {
  __typename?: 'InventoryLocation';
  boxNumber?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<IInventoryLocation>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IInventoryImage>>;
  items?: Maybe<Array<IInventoryItem>>;
  kind: IInventoryLocationKind;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<IInventoryLocation>;
};

export type IInventoryLocationInput = {
  boxNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<IInventoryLocationKind>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

/** The kind of physical location in the inventory location tree */
export enum IInventoryLocationKind {
  Box = 'BOX',
  Other = 'OTHER',
  Room = 'ROOM',
  Shelf = 'SHELF',
  Venue = 'VENUE'
}

export type IInventoryMovement = {
  __typename?: 'InventoryMovement';
  costume?: Maybe<IInventoryCostume>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  fromLocation?: Maybe<IInventoryLocation>;
  fromType?: Maybe<IInventoryHolderType>;
  fromUser?: Maybe<IUser>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<IInventoryImage>>;
  item?: Maybe<IInventoryItem>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<IUser>;
  toLocation?: Maybe<IInventoryLocation>;
  toType?: Maybe<IInventoryHolderType>;
  toUser?: Maybe<IUser>;
  type: IInventoryMovementType;
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** The kind of movement recorded in the inventory ledger */
export enum IInventoryMovementType {
  Checkout = 'CHECKOUT',
  Intake = 'INTAKE',
  Return = 'RETURN',
  TransferLocation = 'TRANSFER_LOCATION',
  TransferPerson = 'TRANSFER_PERSON'
}

/** Item type which can be added to a basket */
export enum IItemType {
  Course = 'COURSE',
  Coursesession = 'COURSESESSION',
  CourseSession = 'COURSE_SESSION',
  Event = 'EVENT',
  EventTier = 'EVENT_TIER',
  Exam = 'EXAM'
}

/** Ability level of the course */
export enum ILevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  Kids_1 = 'KIDS_1',
  Kids_2 = 'KIDS_2',
  KidsFoundation = 'KIDS_FOUNDATION'
}

export type ILineItem = {
  __typename?: 'LineItem';
  /** The item-level promo code applied to this line item, if any */
  appliedItemPromoCode?: Maybe<IPromoCode>;
  assignedUser?: Maybe<IUser>;
  basket?: Maybe<IBasket>;
  chargeFromDate?: Maybe<Scalars['String']['output']>;
  chargeTotal?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<ICourseResult>;
  courseSession?: Maybe<ICourseSession>;
  creditAmount?: Maybe<Scalars['Int']['output']>;
  creditItems?: Maybe<Array<ICreditItem>>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  eventSeat?: Maybe<IEventSeat>;
  eventTier?: Maybe<IEventTier>;
  exam?: Maybe<IExam>;
  feeItems?: Maybe<Array<IFeeItem>>;
  id?: Maybe<Scalars['ID']['output']>;
  orderItem?: Maybe<IOrderItem>;
  orderModifier?: Maybe<IOrderModifier>;
  payDeposit?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  /** Discount value applied from an ITEM promo code */
  promoCodeDiscountValue?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
};

export type ILineItemInfo = {
  assignedUserId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
};

/** Different locations */
export enum ILocationEnum {
  Angel = 'ANGEL',
  Bermondsey = 'BERMONDSEY',
  BondStreet = 'BOND_STREET',
  Bromley = 'BROMLEY',
  CanadaWater = 'CANADA_WATER',
  CentralLondon = 'CENTRAL_LONDON',
  Chiswick = 'CHISWICK',
  EalingBroadway = 'EALING_BROADWAY',
  ElephantAndCastle = 'ELEPHANT_AND_CASTLE',
  Finchley = 'FINCHLEY',
  Hammersmith = 'HAMMERSMITH',
  Hendon = 'HENDON',
  HighBarnet = 'HIGH_BARNET',
  IslandGardens = 'ISLAND_GARDENS',
  OldStreet = 'OLD_STREET',
  Orpington = 'ORPINGTON',
  SevenIsland = 'SEVEN_ISLAND',
  Southwark = 'SOUTHWARK',
  SouthKensington = 'SOUTH_KENSINGTON',
  TowerHill = 'TOWER_HILL',
  Whitechapel = 'WHITECHAPEL',
  Wimbledon = 'WIMBLEDON',
  Zoom = 'ZOOM'
}

export type ILocationSummary = {
  __typename?: 'LocationSummary';
  fullBookings: Scalars['Float']['output'];
  location: Scalars['String']['output'];
  netIncome: Scalars['Float']['output'];
  tasterBookings: Scalars['Float']['output'];
};

export type ILoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type IMergeUserInput = {
  /** User you want to merge into another user */
  fromUserId: Scalars['String']['input'];
  /** User you want to merge all data into */
  toUserId: Scalars['String']['input'];
};

export type IMergeUserOutput = {
  __typename?: 'MergeUserOutput';
  errors?: Maybe<Array<IFieldError>>;
  user: IUser;
};

export type IMissingOrderEntry = {
  __typename?: 'MissingOrderEntry';
  bookingType: Scalars['String']['output'];
  courseId: Scalars['Float']['output'];
  courseName: Scalars['String']['output'];
  parentEmail?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  studentId: Scalars['Float']['output'];
  studentName: Scalars['String']['output'];
};

export type IMutation = {
  __typename?: 'Mutation';
  addCoursesToUser: Array<ICourse>;
  addItem: IBasketResponse;
  addItemToUser: IDefaultResponse;
  addUsersToCourse: Array<IUser>;
  /** Allocate a payment transaction across an order */
  allocateTransactions: Scalars['Boolean']['output'];
  /** Applies a promo code to the user's active basket */
  applyPromoCode: IBasket;
  assignTeacher: ITeachersResponse;
  balanceOrderPayments: IOrderResponse;
  checkoutCostume: IInventoryCostume;
  checkoutItem: IInventoryItem;
  createCourse: ICourse;
  createInventoryCostume: IInventoryCostume;
  createInventoryItem: IInventoryItem;
  createInventoryLocation: IInventoryLocation;
  createOrder: IOrderResponse;
  createOrderFromBasket: IOrderResponse;
  createOrderStripeInvoice: IStripeInvoiceResponse;
  createPaymentIntent: IPaymentIntent;
  /** Create a note for a User-Course relation */
  createUserCourseNote: INotesResponse;
  deleteCourse: ICourse;
  deleteInventoryCostume: IInventoryCostume;
  deleteInventoryItem: IInventoryItem;
  deleteInventoryLocation: IInventoryLocation;
  /** Delete a note */
  deleteNote: INotesResponse;
  deleteOrder: IOrder;
  destroyBasket: Scalars['Boolean']['output'];
  initBasket: IBasketResponse;
  intakeItem: IInventoryItem;
  inventoryIdentify: IUserResponse;
  logEvent: Scalars['Boolean']['output'];
  login: IUserResponse;
  logout: Scalars['Boolean']['output'];
  markStripeInvoiceReceived: IStripeInvoiceResponse;
  mergeUserReq: IMergeUserOutput;
  passwordReset: IPasswordResetResponse;
  passwordResetRequest: IPasswordResetResponse;
  placeOrder: IPlaceOrderResponse;
  register: IUserResponse;
  removeItem: IBasketResponse;
  removeItemFromUser: IDefaultResponse;
  /** Removes any applied promo codes from the user's active basket */
  removePromoCode: IBasket;
  removeUsersFromCourse: Array<IUser>;
  returnCostume: IInventoryCostume;
  returnItem: IInventoryItem;
  runHealthChecks: Array<IHealthCheckResultType>;
  sendStripeInvoice: IStripeInvoiceResponse;
  syncCourseSessionTimes: Scalars['Int']['output'];
  takeOrderPayment: IOrderResponse;
  transferItemLocation: IInventoryItem;
  transferItemToPerson: IInventoryItem;
  unassignTeacher: ITeachersResponse;
  updateAttendanceMatrix: IAttendanceMatrixResponse;
  updateCourse: ICourse;
  updateInventoryCostume: IInventoryCostume;
  updateInventoryItem: IInventoryItem;
  updateInventoryLocation: IInventoryLocation;
  /** Update a note body */
  updateNoteBody: INotesResponse;
  updateOrder: IOrder;
  updateOrderItemPayments: Scalars['Boolean']['output'];
  updatePassword: IPasswordResetResponse;
  updatePaymentIntent: Scalars['Boolean']['output'];
  /** Set if User Credit should be used in the calculation */
  useCreditForBasket: IBasketResponse;
  voidStripeInvoice: IStripeInvoiceResponse;
};


export type IMutationAddCoursesToUserArgs = {
  courseIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type IMutationAddItemArgs = {
  assignToUserId?: InputMaybe<Scalars['String']['input']>;
  basketId?: InputMaybe<Scalars['String']['input']>;
  chargeFromDate?: InputMaybe<Scalars['Float']['input']>;
  itemId: Scalars['Float']['input'];
  itemType: Scalars['String']['input'];
  payDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationAddItemToUserArgs = {
  data: IUserItemInput;
};


export type IMutationAddUsersToCourseArgs = {
  courseId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type IMutationAllocateTransactionsArgs = {
  data: IFixPaymentsInput;
};


export type IMutationApplyPromoCodeArgs = {
  code: Scalars['String']['input'];
};


export type IMutationAssignTeacherArgs = {
  courseId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type IMutationBalanceOrderPaymentsArgs = {
  orderId: Scalars['Float']['input'];
};


export type IMutationCheckoutCostumeArgs = {
  data: ICheckoutCostumeInput;
};


export type IMutationCheckoutItemArgs = {
  data: ICheckoutItemInput;
};


export type IMutationCreateCourseArgs = {
  data: ICourseInput;
};


export type IMutationCreateInventoryCostumeArgs = {
  data: IInventoryCostumeInput;
};


export type IMutationCreateInventoryItemArgs = {
  data: IInventoryItemInput;
};


export type IMutationCreateInventoryLocationArgs = {
  data: IInventoryLocationInput;
};


export type IMutationCreateOrderArgs = {
  basketId?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationCreateOrderFromBasketArgs = {
  basketId?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationCreateOrderStripeInvoiceArgs = {
  data: ICreateOrderStripeInvoiceInput;
};


export type IMutationCreatePaymentIntentArgs = {
  data: ICreatePaymentInput;
};


export type IMutationCreateUserCourseNoteArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type IMutationDeleteCourseArgs = {
  data: ICourseInput;
};


export type IMutationDeleteInventoryCostumeArgs = {
  data: IInventoryIdInput;
};


export type IMutationDeleteInventoryItemArgs = {
  data: IInventoryIdInput;
};


export type IMutationDeleteInventoryLocationArgs = {
  data: IInventoryIdInput;
};


export type IMutationDeleteNoteArgs = {
  noteId: Scalars['String']['input'];
};


export type IMutationDeleteOrderArgs = {
  data: IOrderInput;
};


export type IMutationIntakeItemArgs = {
  data: IIntakeItemInput;
};


export type IMutationInventoryIdentifyArgs = {
  data: IInventoryIdentifyInput;
};


export type IMutationLogEventArgs = {
  key: Scalars['String']['input'];
  metadata: Scalars['String']['input'];
};


export type IMutationLoginArgs = {
  data: ILoginInput;
};


export type IMutationMarkStripeInvoiceReceivedArgs = {
  data: IStripeInvoiceIdInput;
};


export type IMutationMergeUserReqArgs = {
  data: IMergeUserInput;
};


export type IMutationPasswordResetArgs = {
  data: IPasswordResetInput;
};


export type IMutationPasswordResetRequestArgs = {
  data: IPasswordResetReqInput;
};


export type IMutationPlaceOrderArgs = {
  data: IPlaceOrderInput;
};


export type IMutationRegisterArgs = {
  data: ICreateUserInput;
};


export type IMutationRemoveItemArgs = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Float']['input'];
  itemType: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationRemoveItemFromUserArgs = {
  data: IUserItemInput;
};


export type IMutationRemoveUsersFromCourseArgs = {
  courseId: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type IMutationReturnCostumeArgs = {
  data: IReturnCostumeInput;
};


export type IMutationReturnItemArgs = {
  data: IReturnItemInput;
};


export type IMutationSendStripeInvoiceArgs = {
  data: IStripeInvoiceIdInput;
};


export type IMutationSyncCourseSessionTimesArgs = {
  data: ISyncSessionTimesInput;
};


export type IMutationTakeOrderPaymentArgs = {
  data: ITakeOrderPaymentInput;
};


export type IMutationTransferItemLocationArgs = {
  data: ITransferItemLocationInput;
};


export type IMutationTransferItemToPersonArgs = {
  data: ITransferItemToPersonInput;
};


export type IMutationUnassignTeacherArgs = {
  courseId: Scalars['String']['input'];
  teacherId: Scalars['String']['input'];
};


export type IMutationUpdateAttendanceMatrixArgs = {
  attendance: Scalars['Boolean']['input'];
  courseSessionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type IMutationUpdateCourseArgs = {
  data: ICourseInput;
};


export type IMutationUpdateInventoryCostumeArgs = {
  data: IInventoryCostumeInput;
};


export type IMutationUpdateInventoryItemArgs = {
  data: IInventoryItemInput;
};


export type IMutationUpdateInventoryLocationArgs = {
  data: IInventoryLocationInput;
};


export type IMutationUpdateNoteBodyArgs = {
  body: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
};


export type IMutationUpdateOrderArgs = {
  data: IOrderInput;
};


export type IMutationUpdateOrderItemPaymentsArgs = {
  data: IFixPaymentsInput;
};


export type IMutationUpdatePasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};


export type IMutationUpdatePaymentIntentArgs = {
  id: Scalars['String']['input'];
};


export type IMutationUseCreditForBasketArgs = {
  basketId?: InputMaybe<Scalars['String']['input']>;
  useCredit: Scalars['Boolean']['input'];
};


export type IMutationVoidStripeInvoiceArgs = {
  data: IStripeInvoiceIdInput;
};

export type INote = {
  __typename?: 'Note';
  body?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type INotesResponse = {
  __typename?: 'NotesResponse';
  errors?: Maybe<Array<IFieldError>>;
  note?: Maybe<INote>;
  notes?: Maybe<Array<INote>>;
};

export type IOnlineCourse = IICourse & {
  __typename?: 'OnlineCourse';
  active?: Maybe<Scalars['Boolean']['output']>;
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  attendanceTypes: Array<IAttendanceType>;
  availableSpaces?: Maybe<Scalars['Int']['output']>;
  courseGroup?: Maybe<ICourseGroup>;
  currentPrice?: Maybe<Scalars['Int']['output']>;
  danceType?: Maybe<IDanceTypeEnum>;
  days?: Maybe<Scalars['String']['output']>;
  depositEnd?: Maybe<Scalars['DateTime']['output']>;
  depositPrice?: Maybe<Scalars['Int']['output']>;
  depositStart?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<IDisplayStatus>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  exams?: Maybe<Array<IExam>>;
  fullyBooked?: Maybe<Scalars['Boolean']['output']>;
  futureCourseSessions?: Maybe<Array<ICourseSession>>;
  hasTasterClasses?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imagePosition?: Maybe<IPosition>;
  isAcceptingDeposits?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<ILevel>;
  lineItems?: Maybe<ILineItem>;
  listStyle?: Maybe<ICourseListStyle>;
  location?: Maybe<ILocationEnum>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<INote>>;
  order?: Maybe<Scalars['Float']['output']>;
  orderItems?: Maybe<Array<IOrderItem>>;
  originalPrice?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  reducePriceOverTime?: Maybe<Scalars['Boolean']['output']>;
  scheduleData?: Maybe<IScheduleData>;
  sessions?: Maybe<Array<ICourseSession>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<ISiteId>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tasterPrice?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<IUser>;
  teachers?: Maybe<Array<IUser>>;
  term?: Maybe<ITerm>;
  termId?: Maybe<Scalars['Int']['output']>;
  thumbImage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<IUser>>;
  videos?: Maybe<Array<IVideo>>;
  weeks?: Maybe<Scalars['String']['output']>;
  zoomMeeting?: Maybe<IZoomMeeting>;
};

export type IOrder = {
  __typename?: 'Order';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<IUser>;
  creditItems?: Maybe<Array<ICreditItem>>;
  creditTotal?: Maybe<Scalars['Int']['output']>;
  discountTotal?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  feeItems?: Maybe<Array<IFeeItem>>;
  id: Scalars['ID']['output'];
  isSettled?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<IOrderItem>>;
  orderModifiers?: Maybe<Array<IOrderModifier>>;
  outstandingAmount?: Maybe<Scalars['Float']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paymentMethodsUsed?: Maybe<Array<IPaymentMethodType>>;
  paymentTransactions?: Maybe<Array<IPaymentTransaction>>;
  selectedPaymentMethodType: IPaymentMethodType;
  siteId?: Maybe<ISiteId>;
  status: IOrderStatus;
  stripeInvoices?: Maybe<Array<IStripeInvoice>>;
  subTotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  user: IUser;
};

export type IOrderDiagnostic = {
  __typename?: 'OrderDiagnostic';
  createdAt: Scalars['DateTime']['output'];
  creditTotal: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountTotal: Scalars['Int']['output'];
  enrolmentLinks: Array<IEnrolmentLink>;
  hasSiblingWithin15Min: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<IOrderItemSummary>;
  orderId: Scalars['Int']['output'];
  selectedPaymentMethodType?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  subTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<IUserSummary>;
};

export type IOrderInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  userID?: InputMaybe<Scalars['Float']['input']>;
};

export type IOrderItem = {
  __typename?: 'OrderItem';
  amountOutstanding?: Maybe<Scalars['Float']['output']>;
  amountPaid?: Maybe<Scalars['Float']['output']>;
  /** The item-level promo code applied to this item, if any */
  appliedItemPromoCode?: Maybe<IPromoCode>;
  assignedUser?: Maybe<IUser>;
  chargeFromDate?: Maybe<Scalars['String']['output']>;
  chargeTotal?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<ICourseResult>;
  courseSession?: Maybe<ICourseSession>;
  creditAmount?: Maybe<Scalars['Int']['output']>;
  discountValue?: Maybe<Scalars['Int']['output']>;
  eventSeat?: Maybe<IEventSeat>;
  eventTier?: Maybe<IEventTier>;
  exam?: Maybe<IExam>;
  extraChildInfo?: Maybe<IExtraChildInfo>;
  formattedChargeTotal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItemId?: Maybe<Scalars['Float']['output']>;
  lineItems?: Maybe<Array<ILineItem>>;
  order?: Maybe<IOrder>;
  orderModifier?: Maybe<IOrderModifier>;
  payDeposit?: Maybe<Scalars['Boolean']['output']>;
  paymentAllocations?: Maybe<Array<IPaymentAllocation>>;
  price?: Maybe<Scalars['Int']['output']>;
  /** Discount from applied ITEM promo code */
  promoCodeDiscountValue?: Maybe<Scalars['Float']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
};

export type IOrderItemSummary = {
  __typename?: 'OrderItemSummary';
  assignedUserId?: Maybe<Scalars['Int']['output']>;
  chargeTotal: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  courseId?: Maybe<Scalars['Int']['output']>;
  courseSessionId?: Maybe<Scalars['Int']['output']>;
  creditAmount: Scalars['Int']['output'];
  discountValue: Scalars['Int']['output'];
  eventSeatId?: Maybe<Scalars['Int']['output']>;
  eventTierId?: Maybe<Scalars['Int']['output']>;
  examId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  payDeposit: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
  totalPrice: Scalars['Int']['output'];
};

export type IOrderModifier = {
  __typename?: 'OrderModifier';
  basket?: Maybe<IOrderModifier>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<IOrderModifierType>;
  value: Scalars['Float']['output'];
  valueType: IOrderModifierValueType;
};

export enum IOrderModifierCategory {
  General = 'GENERAL',
  Membership = 'MEMBERSHIP',
  SpecialOffer = 'SPECIAL_OFFER',
  UserStatus = 'USER_STATUS'
}

export enum IOrderModifierType {
  Basket = 'BASKET',
  BasketItem = 'BASKET_ITEM',
  Course = 'COURSE',
  OrderItem = 'ORDER_ITEM'
}

export enum IOrderModifierValueType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type IOrderResponse = {
  __typename?: 'OrderResponse';
  errors?: Maybe<Array<IFieldError>>;
  order?: Maybe<IOrder>;
  orders?: Maybe<Array<IOrder>>;
};

export enum IOrderStatus {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Init = 'INIT',
  PaymentPending = 'PAYMENT_PENDING',
  Rejected = 'REJECTED',
  Success = 'SUCCESS'
}

export type IPasswordResetInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type IPasswordResetReqInput = {
  email: Scalars['String']['input'];
};

export type IPasswordResetResponse = {
  __typename?: 'PasswordResetResponse';
  errors?: Maybe<Array<IFieldError>>;
  success?: Maybe<Scalars['String']['output']>;
};

export type IPayment = {
  amount: Scalars['Float']['input'];
  paymentMethodType: IPaymentMethodType;
};

export type IPaymentAllocation = {
  __typename?: 'PaymentAllocation';
  amount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  orderItem: IOrderItem;
  paymentTransaction: IPaymentTransaction;
};

export type IPaymentIntent = {
  __typename?: 'PaymentIntent';
  amount: Scalars['Float']['output'];
  amountCapturable: Scalars['Float']['output'];
  amountReceived: Scalars['Float']['output'];
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeId: Scalars['String']['output'];
  user: IUser;
};

export type IPaymentIntentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
};

export type IPaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<IStripeCard>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type IPaymentMethodSummary = {
  __typename?: 'PaymentMethodSummary';
  catsFull: Scalars['Float']['output'];
  catsTaster: Scalars['Float']['output'];
  paymentMethod: Scalars['String']['output'];
  ukcpaFull: Scalars['Float']['output'];
  ukcpaTaster: Scalars['Float']['output'];
};

export enum IPaymentMethodType {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Correction = 'CORRECTION',
  Credit = 'CREDIT',
  Transfer = 'TRANSFER',
  Wechat = 'WECHAT',
  WechatTransfer = 'WECHAT_TRANSFER'
}

export type IPaymentMethodsResponse = {
  __typename?: 'PaymentMethodsResponse';
  paymentMethods: Array<IPaymentMethod>;
  publicKey: Scalars['String']['output'];
};

export type IPaymentNextAction = {
  __typename?: 'PaymentNextAction';
  clientSecret?: Maybe<Scalars['String']['output']>;
  redirectToUrl?: Maybe<IRedirectToUrl>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IPaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  availableAmount?: Maybe<Scalars['Float']['output']>;
  createdById: Scalars['Float']['output'];
  creditItem: ICreditItem;
  depositPayment?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order: IOrder;
  paymentAllocations?: Maybe<Array<IPaymentAllocation>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodType: IPaymentMethodType;
  status?: Maybe<IPaymentTransactionStatus>;
  stripeAccount?: Maybe<Scalars['String']['output']>;
  updatedById: Scalars['Float']['output'];
};

export enum IPaymentTransactionStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Init = 'INIT',
  Other = 'OTHER',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  Success = 'SUCCESS'
}

export type IPendingOrderResult = {
  __typename?: 'PendingOrderResult';
  age: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creditTotal: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type IPlaceOrderInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  lineItemInfo?: InputMaybe<Array<ILineItemInfo>>;
  orderId?: InputMaybe<Scalars['Float']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: IPaymentMethodType;
};

export type IPlaceOrderResponse = {
  __typename?: 'PlaceOrderResponse';
  errors?: Maybe<Array<IFieldError>>;
  nextAction?: Maybe<IPaymentNextAction>;
  order?: Maybe<IOrder>;
  paymentTransactionStatus?: Maybe<IPaymentTransactionStatus>;
  status?: Maybe<IOrderStatus>;
};

export type IPosition = {
  __typename?: 'Position';
  X?: Maybe<Scalars['Float']['output']>;
  Y?: Maybe<Scalars['Float']['output']>;
};

export type IProblemsSummary = {
  __typename?: 'ProblemsSummary';
  extraPaymentsCatsFull: Scalars['Float']['output'];
  extraPaymentsCatsTaster: Scalars['Float']['output'];
  extraPaymentsUkcpaFull: Scalars['Float']['output'];
  extraPaymentsUkcpaTaster: Scalars['Float']['output'];
  missingOrdersCatsFull: Scalars['Float']['output'];
  missingOrdersCatsTaster: Scalars['Float']['output'];
  missingOrdersUkcpaFull: Scalars['Float']['output'];
  missingOrdersUkcpaTaster: Scalars['Float']['output'];
};

/** Represents a promotional code for discounts */
export type IPromoCode = {
  __typename?: 'PromoCode';
  /** Date when the code becomes active */
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Date when the code expires */
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the specific Course, Exam, or CourseSession (if type is ITEM) */
  applicableItemId?: Maybe<Scalars['Int']['output']>;
  /** Type of item the code applies to (if type is ITEM) */
  applicableItemType?: Maybe<IApplicableItemType>;
  /** Baskets where this code is applied as a basket-level discount */
  appliedToBaskets?: Maybe<Array<IBasket>>;
  /** Order items where this code is applied as an item-level discount */
  appliedToOrderItems?: Maybe<Array<IOrderItem>>;
  /** The code string users enter (case-insensitive lookup) */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Admin-facing description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the code is currently enabled */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Categories of OrderModifiers this code might conflict with/override */
  incompatibleModifierCategories?: Maybe<Array<IOrderModifierCategory>>;
  /** How code interacts with existing OrderModifiers */
  interactionPolicy: IPromoCodeInteractionPolicy;
  /** Overall usage limit across all users (null means unlimited) */
  maxTotalUses?: Maybe<Scalars['Int']['output']>;
  /** Max times a single user can use this code */
  maxUsesPerUser: Scalars['Int']['output'];
  /** Specifies if code is for NEW, EXISTING, or ANY user */
  requiredUserStatus: IPromoCodeRequiredUserStatus;
  /** How many times the code has been used overall (for MULTI_USE with maxTotalUses) */
  timesUsed: Scalars['Int']['output'];
  /** Scope of the discount (BASKET or ITEM) */
  type: IPromoCodeType;
  updatedAt: Scalars['DateTime']['output'];
  /** How usage is limited (per user or overall) */
  usageLimit: IPromoCodeUsageLimit;
  /** The discount amount or percentage */
  value: Scalars['Float']['output'];
  /** How the value is interpreted (FIXED amount or PERCENTAGE) */
  valueType: IPromoCodeValueType;
};

export enum IPromoCodeInteractionPolicy {
  Allow = 'ALLOW',
  OverrideIncompatible = 'OVERRIDE_INCOMPATIBLE',
  RejectIfIncompatible = 'REJECT_IF_INCOMPATIBLE'
}

export enum IPromoCodeRequiredUserStatus {
  Any = 'ANY',
  Existing = 'EXISTING',
  New = 'NEW'
}

export enum IPromoCodeType {
  Basket = 'BASKET',
  Item = 'ITEM'
}

export enum IPromoCodeUsageLimit {
  MultiUse = 'MULTI_USE',
  SingleUser = 'SINGLE_USER'
}

export enum IPromoCodeValueType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type IQuery = {
  __typename?: 'Query';
  attendingStudents: IUserResponse;
  bookingSummaryReport: IBookingReportResponse;
  bookingsReport: Array<ICourseBookingsCount>;
  courseAttendance: IAttendanceMatrixResponse;
  courseAttendanceCount: Array<ICourseAttendanceCount>;
  courseTeachers: ITeachersResponse;
  dailyBookingSummaryReport: IBookingReportResponse;
  diagnosticSchemaInventory: ISchemaInventory;
  enrolmentTrace: IEnrolmentDiagnostic;
  eventTicketsEmail: IEventResponse;
  findDoubleCharges: Array<IDoubleChargeCandidate>;
  fixEventSeats: IFixEventBookingsResponse;
  getBasket: IBasketResponse;
  getCourse: ICourseResult;
  getCourseGroup: ICourseGroup;
  getCourseSession: ICourseSession;
  getCourseVideos: Array<IVideo>;
  getCourses: ICourseResponse;
  getDuplicateBasketItems: Array<Scalars['Int']['output']>;
  getEvents: IEventResponse;
  getExam: IExam;
  getExams: Array<IExamGroup>;
  getInventoryCostume: IInventoryCostume;
  getInventoryCostumes: Array<IInventoryCostume>;
  getInventoryItem: IInventoryItem;
  getInventoryItems: Array<IInventoryItem>;
  getInventoryLocation: IInventoryLocation;
  getInventoryLocations: Array<IInventoryLocation>;
  /** Endpoint to return an order which belongs to the context user */
  getOrder: IOrderResponse;
  getOrders: IOrderResponse;
  getPaymentIntent: IPaymentIntent;
  getPaymentMethods: IPaymentMethodsResponse;
  getSearchables: ISearchable;
  getSiteTerms: ISitesTermResponse;
  getStripe: Scalars['String']['output'];
  getTasterCourses: Array<ICourseResult>;
  getTerms: ITermResponse;
  getUnsettledOrders: IOrderResponse;
  getUserEventSummary: IEventSummaryResponse;
  healthCheckResults: Array<IHealthCheckResultType>;
  inventoryItem?: Maybe<IInventoryItem>;
  inventoryItemsAwaitingIntake: Array<IInventoryItem>;
  inventoryItemsHeldByUser: Array<IInventoryItem>;
  inventoryLocationContents: Array<IInventoryItem>;
  inventoryLocations: Array<IInventoryLocation>;
  loginGet: IUserResponse;
  me: IUserResponse;
  meChildren: IUserResponse;
  meCredit: IUserResponse;
  meDetails: IUserResponse;
  meOrders: IOrderResponse;
  orderDiagnostic?: Maybe<IOrderDiagnostic>;
  pendingOrders: Array<IPendingOrderResult>;
  pendingStudents: IUserResponse;
  searchInventory: Array<IInventoryItem>;
  stripeInvoicesForOrder: Array<IStripeInvoice>;
  stripePaymentDiagnostic?: Maybe<IStripePaymentDiagnostic>;
  teacherCourses: ITeacherCoursesResponse;
  teacherScheduleReport: ITeacherScheduleReportResponse;
  teachersList: ITeachersResponse;
  termAttendanceDownload: Array<IAttendanceDownloadCourse>;
  termBookingsReport: ITermBookingsReportResponse;
  userCourses: ICourseResponse;
  userPaymentHistory?: Maybe<IUserPaymentHistory>;
};


export type IQueryAttendingStudentsArgs = {
  courseId: Scalars['String']['input'];
};


export type IQueryBookingsReportArgs = {
  attendanceType?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['String']['input'];
  termId?: InputMaybe<Scalars['Float']['input']>;
  toDate: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryCourseAttendanceArgs = {
  courseId: Scalars['String']['input'];
};


export type IQueryCourseAttendanceCountArgs = {
  courseId: Scalars['String']['input'];
};


export type IQueryCourseTeachersArgs = {
  courseId: Scalars['String']['input'];
};


export type IQueryDailyBookingSummaryReportArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryEnrolmentTraceArgs = {
  courseId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type IQueryEventTicketsEmailArgs = {
  data: IEventSummaryInput;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IQueryFindDoubleChargesArgs = {
  daysWindow?: InputMaybe<Scalars['Int']['input']>;
  sinceDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type IQueryGetCourseArgs = {
  id: Scalars['Float']['input'];
};


export type IQueryGetCourseGroupArgs = {
  displayStatus?: InputMaybe<IDisplayStatus>;
  id: Scalars['Float']['input'];
};


export type IQueryGetCourseSessionArgs = {
  id: Scalars['Float']['input'];
};


export type IQueryGetCourseVideosArgs = {
  data: ICourseVideoInput;
};


export type IQueryGetCoursesArgs = {
  data: ICourseSearchInput;
};


export type IQueryGetEventsArgs = {
  data: IEventSearchInput;
};


export type IQueryGetExamArgs = {
  id: Scalars['Float']['input'];
};


export type IQueryGetInventoryCostumeArgs = {
  data: IInventoryCostumeInput;
};


export type IQueryGetInventoryItemArgs = {
  data: IInventoryItemInput;
};


export type IQueryGetInventoryLocationArgs = {
  data: IInventoryLocationInput;
};


export type IQueryGetOrderArgs = {
  data: IOrderInput;
};


export type IQueryGetOrdersArgs = {
  data: IOrderInput;
};


export type IQueryGetPaymentIntentArgs = {
  data: IPaymentIntentInput;
};


export type IQueryGetSiteTermsArgs = {
  data: ITermInput;
};


export type IQueryGetTasterCoursesArgs = {
  data: ICourseSearchInput;
};


export type IQueryGetTermsArgs = {
  data: ITermInput;
};


export type IQueryGetUnsettledOrdersArgs = {
  data: IOrderInput;
};


export type IQueryGetUserEventSummaryArgs = {
  data: IEventSummaryInput;
};


export type IQueryInventoryItemArgs = {
  id: Scalars['Int']['input'];
};


export type IQueryInventoryItemsHeldByUserArgs = {
  userId: Scalars['Int']['input'];
};


export type IQueryInventoryLocationContentsArgs = {
  locationId: Scalars['Int']['input'];
};


export type IQueryLoginGetArgs = {
  data: ILoginInput;
};


export type IQueryOrderDiagnosticArgs = {
  orderId: Scalars['Int']['input'];
};


export type IQueryPendingStudentsArgs = {
  courseId: Scalars['String']['input'];
};


export type IQuerySearchInventoryArgs = {
  term: Scalars['String']['input'];
};


export type IQueryStripeInvoicesForOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type IQueryStripePaymentDiagnosticArgs = {
  paymentIntentId: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryTeacherCoursesArgs = {
  teacherId: Scalars['String']['input'];
};


export type IQueryTeacherScheduleReportArgs = {
  termId?: InputMaybe<Scalars['Float']['input']>;
};


export type IQueryTermAttendanceDownloadArgs = {
  termId: Scalars['Float']['input'];
};


export type IQueryTermBookingsReportArgs = {
  termId: Scalars['Float']['input'];
};


export type IQueryUserCoursesArgs = {
  userId: Scalars['String']['input'];
};


export type IQueryUserPaymentHistoryArgs = {
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type IRedirectToUrl = {
  __typename?: 'RedirectToURL';
  returnUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type IReturnCostumeInput = {
  costumeId: Scalars['Int']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  toLocationId: Scalars['Int']['input'];
};

export type IReturnItemInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toLocationId: Scalars['Int']['input'];
};

export enum IRole {
  Admin = 'ADMIN',
  Engineering = 'ENGINEERING',
  Finance = 'FINANCE',
  Teacher = 'TEACHER',
  User = 'USER'
}

export type IScheduleData = {
  __typename?: 'ScheduleData';
  fallbackText: Scalars['String']['output'];
  patterns: Array<ISchedulePattern>;
  summary: IScheduleSummary;
  type: IScheduleType;
};

export type ISchedulePattern = {
  __typename?: 'SchedulePattern';
  days: Array<Scalars['String']['output']>;
  sessions?: Maybe<Scalars['Float']['output']>;
  time: Scalars['String']['output'];
};

export type IScheduleSummary = {
  __typename?: 'ScheduleSummary';
  primary: Scalars['String']['output'];
  simple: Scalars['String']['output'];
};

/** The type of schedule pattern for a course */
export enum IScheduleType {
  MultipleTimes = 'MULTIPLE_TIMES',
  Regular = 'REGULAR',
  Tbd = 'TBD',
  Varies = 'VARIES'
}

export type ISchemaInventory = {
  __typename?: 'SchemaInventory';
  queries: Array<IDiagnosticQueryDescriptor>;
  version: Scalars['String']['output'];
};

export type ISearchable = {
  __typename?: 'Searchable';
  danceTypes?: Maybe<Array<IDanceTypeEnum>>;
  locations?: Maybe<Array<ILocationEnum>>;
};

export type ISite = {
  __typename?: 'Site';
  name: Scalars['String']['output'];
  terms: Array<ITerm>;
};

/** Site identifier to handle multiple sites */
export enum ISiteId {
  Cats = 'CATS',
  Ukcpa = 'UKCPA'
}

export type ISiteTotals = {
  __typename?: 'SiteTotals';
  catsFull: Scalars['Float']['output'];
  catsTaster: Scalars['Float']['output'];
  ukcpaFull: Scalars['Float']['output'];
  ukcpaTaster: Scalars['Float']['output'];
};

export type ISitesTermResponse = {
  __typename?: 'SitesTermResponse';
  sites?: Maybe<Array<ISite>>;
};

export type IStripeCard = {
  __typename?: 'StripeCard';
  brand: Scalars['String']['output'];
  country: Scalars['String']['output'];
  expMonth: Scalars['Float']['output'];
  expYear: Scalars['Float']['output'];
  last4: Scalars['String']['output'];
};

export type IStripeChargeDiagnostic = {
  __typename?: 'StripeChargeDiagnostic';
  amount: Scalars['Int']['output'];
  amountRefunded: Scalars['Int']['output'];
  captured: Scalars['Boolean']['output'];
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardCountry?: Maybe<Scalars['String']['output']>;
  cardExpMonth?: Maybe<Scalars['Int']['output']>;
  cardExpYear?: Maybe<Scalars['Int']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  refunded: Scalars['Boolean']['output'];
  refunds: Array<IStripeRefundDiagnostic>;
  status: Scalars['String']['output'];
};

export type IStripeInvoice = {
  __typename?: 'StripeInvoice';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<IUser>;
  currency: Scalars['String']['output'];
  finalizedAt?: Maybe<Scalars['DateTime']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<IOrder>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidOutOfBand: Scalars['Boolean']['output'];
  paymentTransaction?: Maybe<IPaymentTransaction>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  siteId: ISiteId;
  status: IStripeInvoiceStatus;
  stripeAccountId: Scalars['String']['output'];
  stripeInvoiceId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IStripeInvoiceIdInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  stripeInvoiceRowId: Scalars['Int']['input'];
};

export type IStripeInvoiceResponse = {
  __typename?: 'StripeInvoiceResponse';
  errors?: Maybe<Array<IFieldError>>;
  invoice?: Maybe<IStripeInvoice>;
};

/** Status of a Stripe invoice raised against an order */
export enum IStripeInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type IStripePaymentDiagnostic = {
  __typename?: 'StripePaymentDiagnostic';
  accountsTried: Array<Scalars['String']['output']>;
  amount: Scalars['Int']['output'];
  amountCapturable: Scalars['Int']['output'];
  amountReceived: Scalars['Int']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  charges: Array<IStripeChargeDiagnostic>;
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  disputeStatus?: Maybe<Scalars['String']['output']>;
  hasDispute: Scalars['Boolean']['output'];
  paymentIntentId: Scalars['String']['output'];
  retrievedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  stripeAccount: Scalars['String']['output'];
  totalRefunded: Scalars['Int']['output'];
};

export type IStripeRefundDiagnostic = {
  __typename?: 'StripeRefundDiagnostic';
  amount: Scalars['Int']['output'];
  chargeId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type IStudentAttendanceMatrix = {
  __typename?: 'StudentAttendanceMatrix';
  attendanceMatrix: Array<IAttendanceMatrix>;
  userId: Scalars['Float']['output'];
};

export type IStudioCourse = IICourse & {
  __typename?: 'StudioCourse';
  active?: Maybe<Scalars['Boolean']['output']>;
  address: IAddress;
  ageFrom?: Maybe<Scalars['Int']['output']>;
  ageTo?: Maybe<Scalars['Int']['output']>;
  attendanceTypes: Array<IAttendanceType>;
  availableSpaces?: Maybe<Scalars['Int']['output']>;
  courseGroup?: Maybe<ICourseGroup>;
  currentPrice?: Maybe<Scalars['Int']['output']>;
  danceType?: Maybe<IDanceTypeEnum>;
  days?: Maybe<Scalars['String']['output']>;
  depositEnd?: Maybe<Scalars['DateTime']['output']>;
  depositPrice?: Maybe<Scalars['Int']['output']>;
  depositStart?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayStatus?: Maybe<IDisplayStatus>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  exams?: Maybe<Array<IExam>>;
  fullyBooked?: Maybe<Scalars['Boolean']['output']>;
  futureCourseSessions?: Maybe<Array<ICourseSession>>;
  hasTasterClasses?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imagePosition?: Maybe<IPosition>;
  instructions?: Maybe<Scalars['String']['output']>;
  isAcceptingDeposits?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<ILevel>;
  lineItems?: Maybe<ILineItem>;
  listStyle?: Maybe<ICourseListStyle>;
  location?: Maybe<ILocationEnum>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<INote>>;
  order?: Maybe<Scalars['Float']['output']>;
  orderItems?: Maybe<Array<IOrderItem>>;
  originalPrice?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  reducePriceOverTime?: Maybe<Scalars['Boolean']['output']>;
  scheduleData?: Maybe<IScheduleData>;
  sessions?: Maybe<Array<ICourseSession>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<ISiteId>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tasterPrice?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<IUser>;
  teachers?: Maybe<Array<IUser>>;
  term?: Maybe<ITerm>;
  termId?: Maybe<Scalars['Int']['output']>;
  thumbImage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<IUser>>;
  videos?: Maybe<Array<IVideo>>;
  weeks?: Maybe<Scalars['String']['output']>;
};

export type ISyncSessionTimesInput = {
  courseId: Scalars['Int']['input'];
};

export type ITakeOrderPaymentInput = {
  allocations: Array<IAllocation>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Float']['input'];
  payment: IPayment;
};

export type ITeacherCoursesResponse = {
  __typename?: 'TeacherCoursesResponse';
  courses?: Maybe<Array<ICourse>>;
};

export type ITeacherScheduleItem = {
  __typename?: 'TeacherScheduleItem';
  className: Scalars['String']['output'];
  classType: Scalars['String']['output'];
  courseId: Scalars['Float']['output'];
  days: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  location: Scalars['String']['output'];
  studentCount: Scalars['Float']['output'];
  teacherId: Scalars['Float']['output'];
  teacherName: Scalars['String']['output'];
  timeSlot: Scalars['String']['output'];
};

export type ITeacherScheduleReportResponse = {
  __typename?: 'TeacherScheduleReportResponse';
  schedules: Array<ITeacherScheduleItem>;
};

export type ITeachersResponse = {
  __typename?: 'TeachersResponse';
  teachers: Array<IUser>;
};

export type ITerm = {
  __typename?: 'Term';
  courseGroups?: Maybe<Array<ICourseGroup>>;
  courses?: Maybe<Array<ICourse>>;
  displayStatus?: Maybe<IDisplayStatus>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  holidays?: Maybe<Array<IClassHoliday>>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sites?: Maybe<Array<ISiteId>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ITermBookingsReportResponse = {
  __typename?: 'TermBookingsReportResponse';
  courseTypeSummary: Array<ICourseTypeSummary>;
  creditUsage: ICreditUsage;
  extraPayments: Array<IExtraPaymentEntry>;
  fullOrderSummary: Array<ICourseOrderSummary>;
  fullPaymentMethods: Array<ICoursePaymentMethod>;
  locationSummary: Array<ILocationSummary>;
  missingOrders: Array<IMissingOrderEntry>;
  paymentMethodSummary: Array<IPaymentMethodSummary>;
  problemsSummary: IProblemsSummary;
  siteTotals: ISiteTotals;
  tasterOrderSummary: Array<ICourseOrderSummary>;
  tasterPaymentMethods: Array<ICoursePaymentMethod>;
};

export type ITermInput = {
  displayStatus?: InputMaybe<IDisplayStatus>;
  termId?: InputMaybe<Scalars['String']['input']>;
};

export type ITermResponse = {
  __typename?: 'TermResponse';
  term?: Maybe<ITerm>;
  terms?: Maybe<Array<ITerm>>;
};

export type IToken = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expires: Scalars['Float']['output'];
  token: Scalars['String']['output'];
  user: IUser;
};

export type ITransferItemLocationInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toLocationId: Scalars['Int']['input'];
};

export type ITransferItemToPersonInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  toUserId: Scalars['Int']['input'];
};

export type IUser = {
  __typename?: 'User';
  address?: Maybe<IAddress>;
  age?: Maybe<Scalars['Float']['output']>;
  assignedBasketItems: Array<ILineItem>;
  assignedOrderItems: Array<IOrderItem>;
  attendance: Array<IAttendance>;
  baskets?: Maybe<Array<IBasket>>;
  catsStripeCustomerId?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<IUser>>;
  courseSessions?: Maybe<Array<ICourseSession>>;
  courses?: Maybe<Array<ICourseResult>>;
  creditAvailable?: Maybe<Scalars['Float']['output']>;
  creditTotal?: Maybe<Scalars['Float']['output']>;
  creditUsed?: Maybe<Scalars['Float']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventSeats?: Maybe<Array<IEventSeat>>;
  exams?: Maybe<Array<IExam>>;
  firstName: Scalars['String']['output'];
  googleId?: Maybe<Scalars['String']['output']>;
  heardAboutUs?: Maybe<IHeardAboutUs>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  notes?: Maybe<Array<INote>>;
  orders?: Maybe<Array<IOrder>>;
  parent?: Maybe<IUser>;
  password?: Maybe<Scalars['String']['output']>;
  paymentIntents: Array<IPaymentIntent>;
  phone?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  ribbonStripeCustomerId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<IRole>;
  roles?: Maybe<Array<IRole>>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeRibbonCustomerId?: Maybe<Scalars['String']['output']>;
  teachingCourses?: Maybe<Array<ICourse>>;
  tokens?: Maybe<Array<IToken>>;
  weChatId?: Maybe<Scalars['String']['output']>;
  zoomUserId?: Maybe<Scalars['String']['output']>;
};

export type IUserCreditItemEntry = {
  __typename?: 'UserCreditItemEntry';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['Int']['output'];
};

export type IUserEventSummary = {
  __typename?: 'UserEventSummary';
  address: IAddress;
  description: Scalars['String']['output'];
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  seats: Scalars['Float']['output'];
  startDateTime: Scalars['DateTime']['output'];
  tierBookings: Array<IEtb>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type IUserItemInput = {
  itemId: Scalars['Float']['input'];
  itemType: IItemType;
  userId: Scalars['Float']['input'];
};

export type IUserOrderEntry = {
  __typename?: 'UserOrderEntry';
  createdAt: Scalars['DateTime']['output'];
  creditTotal: Scalars['Int']['output'];
  hasSiblingWithin15Min: Scalars['Boolean']['output'];
  orderId: Scalars['Int']['output'];
  siteId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type IUserPaymentHistory = {
  __typename?: 'UserPaymentHistory';
  creditBalance: Scalars['Int']['output'];
  doubleChargeIncidents: Scalars['Int']['output'];
  hasEmail: Scalars['Boolean']['output'];
  recentCreditItems: Array<IUserCreditItemEntry>;
  recentOrders: Array<IUserOrderEntry>;
  sinceDays: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalPaid: Scalars['Int']['output'];
  totalRefunded: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type IUserResponse = {
  __typename?: 'UserResponse';
  children?: Maybe<Array<IUser>>;
  creditAvailable?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Array<IFieldError>>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
  users?: Maybe<Array<IUser>>;
};

export type IUserSummary = {
  __typename?: 'UserSummary';
  hasEmail: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type IVideo = {
  __typename?: 'Video';
  course?: Maybe<ICourse>;
  description?: Maybe<Scalars['String']['output']>;
  /** Control when the students can view the video */
  displayStatus?: Maybe<IDisplayStatus>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  provider: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IZoomMeeting = {
  __typename?: 'ZoomMeeting';
  meetingId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
};

export type IInventoryLocationFragmentFragment = { __typename?: 'InventoryLocation', id: string, name: string, boxNumber?: string | null, kind: IInventoryLocationKind, parent?: { __typename?: 'InventoryLocation', id: string, name: string } | null };

export type IInventoryItemFragmentFragment = { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null };

export type IInventoryIdentifyMutationVariables = Exact<{
  data: IInventoryIdentifyInput;
}>;


export type IInventoryIdentifyMutation = { __typename?: 'Mutation', inventoryIdentify: { __typename?: 'UserResponse', token?: string | null, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, errors?: Array<{ __typename?: 'FieldError', path: string, message: string }> | null } };

export type ISearchInventoryQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type ISearchInventoryQuery = { __typename?: 'Query', searchInventory: Array<{ __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null }> };

export type IInventoryItemsHeldByUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type IInventoryItemsHeldByUserQuery = { __typename?: 'Query', inventoryItemsHeldByUser: Array<{ __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null }> };

export type IInventoryLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IInventoryLocationsQuery = { __typename?: 'Query', inventoryLocations: Array<{ __typename?: 'InventoryLocation', id: string, name: string, boxNumber?: string | null, kind: IInventoryLocationKind, parent?: { __typename?: 'InventoryLocation', id: string, name: string } | null }> };

export type IInventoryItemQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type IInventoryItemQuery = { __typename?: 'Query', inventoryItem?: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } | null };

export type ICheckoutItemMutationVariables = Exact<{
  data: ICheckoutItemInput;
}>;


export type ICheckoutItemMutation = { __typename?: 'Mutation', checkoutItem: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } };

export type IReturnItemMutationVariables = Exact<{
  data: IReturnItemInput;
}>;


export type IReturnItemMutation = { __typename?: 'Mutation', returnItem: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } };

export type ITransferItemLocationMutationVariables = Exact<{
  data: ITransferItemLocationInput;
}>;


export type ITransferItemLocationMutation = { __typename?: 'Mutation', transferItemLocation: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } };

export type ITransferItemToPersonMutationVariables = Exact<{
  data: ITransferItemToPersonInput;
}>;


export type ITransferItemToPersonMutation = { __typename?: 'Mutation', transferItemToPerson: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } };

export type IIntakeItemMutationVariables = Exact<{
  data: IIntakeItemInput;
}>;


export type IIntakeItemMutation = { __typename?: 'Mutation', intakeItem: { __typename?: 'InventoryItem', id: string, name: string, description?: string | null, assetTag?: string | null, status: IInventoryItemStatus, holderType?: IInventoryHolderType | null, currentLocationId?: string | null, currentHolderUserId?: string | null, currentLocation?: { __typename?: 'InventoryLocation', id: string, name: string, kind: IInventoryLocationKind } | null, currentHolderUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email?: string | null } | null, costume?: { __typename?: 'InventoryCostume', id: string, name: string } | null, images?: Array<{ __typename?: 'InventoryImage', id: string, url: string, type: IInventoryImageType }> | null } };

export const InventoryLocationFragmentFragmentDoc = gql`
    fragment InventoryLocationFragment on InventoryLocation {
  id
  name
  boxNumber
  kind
  parent {
    id
    name
  }
}
    `;
export const InventoryItemFragmentFragmentDoc = gql`
    fragment InventoryItemFragment on InventoryItem {
  id
  name
  description
  assetTag
  status
  holderType
  currentLocationId
  currentHolderUserId
  currentLocation {
    id
    name
    kind
  }
  currentHolderUser {
    id
    firstName
    lastName
    email
  }
  costume {
    id
    name
  }
  images {
    id
    url
    type
  }
}
    `;
export const InventoryIdentifyDocument = gql`
    mutation InventoryIdentify($data: InventoryIdentifyInput!) {
  inventoryIdentify(data: $data) {
    token
    user {
      id
      firstName
      lastName
      email
    }
    errors {
      path
      message
    }
  }
}
    `;
export type IInventoryIdentifyMutationFn = Apollo.MutationFunction<IInventoryIdentifyMutation, IInventoryIdentifyMutationVariables>;

/**
 * __useInventoryIdentifyMutation__
 *
 * To run a mutation, you first call `useInventoryIdentifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInventoryIdentifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inventoryIdentifyMutation, { data, loading, error }] = useInventoryIdentifyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInventoryIdentifyMutation(baseOptions?: Apollo.MutationHookOptions<IInventoryIdentifyMutation, IInventoryIdentifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInventoryIdentifyMutation, IInventoryIdentifyMutationVariables>(InventoryIdentifyDocument, options);
      }
export type InventoryIdentifyMutationHookResult = ReturnType<typeof useInventoryIdentifyMutation>;
export type InventoryIdentifyMutationResult = Apollo.MutationResult<IInventoryIdentifyMutation>;
export type InventoryIdentifyMutationOptions = Apollo.BaseMutationOptions<IInventoryIdentifyMutation, IInventoryIdentifyMutationVariables>;
export const SearchInventoryDocument = gql`
    query SearchInventory($term: String!) {
  searchInventory(term: $term) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;

/**
 * __useSearchInventoryQuery__
 *
 * To run a query within a React component, call `useSearchInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInventoryQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchInventoryQuery(baseOptions: Apollo.QueryHookOptions<ISearchInventoryQuery, ISearchInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchInventoryQuery, ISearchInventoryQueryVariables>(SearchInventoryDocument, options);
      }
export function useSearchInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchInventoryQuery, ISearchInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchInventoryQuery, ISearchInventoryQueryVariables>(SearchInventoryDocument, options);
        }
export type SearchInventoryQueryHookResult = ReturnType<typeof useSearchInventoryQuery>;
export type SearchInventoryLazyQueryHookResult = ReturnType<typeof useSearchInventoryLazyQuery>;
export type SearchInventoryQueryResult = Apollo.QueryResult<ISearchInventoryQuery, ISearchInventoryQueryVariables>;
export const InventoryItemsHeldByUserDocument = gql`
    query InventoryItemsHeldByUser($userId: Int!) {
  inventoryItemsHeldByUser(userId: $userId) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;

/**
 * __useInventoryItemsHeldByUserQuery__
 *
 * To run a query within a React component, call `useInventoryItemsHeldByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemsHeldByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemsHeldByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInventoryItemsHeldByUserQuery(baseOptions: Apollo.QueryHookOptions<IInventoryItemsHeldByUserQuery, IInventoryItemsHeldByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInventoryItemsHeldByUserQuery, IInventoryItemsHeldByUserQueryVariables>(InventoryItemsHeldByUserDocument, options);
      }
export function useInventoryItemsHeldByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInventoryItemsHeldByUserQuery, IInventoryItemsHeldByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInventoryItemsHeldByUserQuery, IInventoryItemsHeldByUserQueryVariables>(InventoryItemsHeldByUserDocument, options);
        }
export type InventoryItemsHeldByUserQueryHookResult = ReturnType<typeof useInventoryItemsHeldByUserQuery>;
export type InventoryItemsHeldByUserLazyQueryHookResult = ReturnType<typeof useInventoryItemsHeldByUserLazyQuery>;
export type InventoryItemsHeldByUserQueryResult = Apollo.QueryResult<IInventoryItemsHeldByUserQuery, IInventoryItemsHeldByUserQueryVariables>;
export const InventoryLocationsDocument = gql`
    query InventoryLocations {
  inventoryLocations {
    ...InventoryLocationFragment
  }
}
    ${InventoryLocationFragmentFragmentDoc}`;

/**
 * __useInventoryLocationsQuery__
 *
 * To run a query within a React component, call `useInventoryLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryLocationsQuery(baseOptions?: Apollo.QueryHookOptions<IInventoryLocationsQuery, IInventoryLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInventoryLocationsQuery, IInventoryLocationsQueryVariables>(InventoryLocationsDocument, options);
      }
export function useInventoryLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInventoryLocationsQuery, IInventoryLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInventoryLocationsQuery, IInventoryLocationsQueryVariables>(InventoryLocationsDocument, options);
        }
export type InventoryLocationsQueryHookResult = ReturnType<typeof useInventoryLocationsQuery>;
export type InventoryLocationsLazyQueryHookResult = ReturnType<typeof useInventoryLocationsLazyQuery>;
export type InventoryLocationsQueryResult = Apollo.QueryResult<IInventoryLocationsQuery, IInventoryLocationsQueryVariables>;
export const InventoryItemDocument = gql`
    query InventoryItem($id: Int!) {
  inventoryItem(id: $id) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;

/**
 * __useInventoryItemQuery__
 *
 * To run a query within a React component, call `useInventoryItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInventoryItemQuery(baseOptions: Apollo.QueryHookOptions<IInventoryItemQuery, IInventoryItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IInventoryItemQuery, IInventoryItemQueryVariables>(InventoryItemDocument, options);
      }
export function useInventoryItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IInventoryItemQuery, IInventoryItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IInventoryItemQuery, IInventoryItemQueryVariables>(InventoryItemDocument, options);
        }
export type InventoryItemQueryHookResult = ReturnType<typeof useInventoryItemQuery>;
export type InventoryItemLazyQueryHookResult = ReturnType<typeof useInventoryItemLazyQuery>;
export type InventoryItemQueryResult = Apollo.QueryResult<IInventoryItemQuery, IInventoryItemQueryVariables>;
export const CheckoutItemDocument = gql`
    mutation CheckoutItem($data: CheckoutItemInput!) {
  checkoutItem(data: $data) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;
export type ICheckoutItemMutationFn = Apollo.MutationFunction<ICheckoutItemMutation, ICheckoutItemMutationVariables>;

/**
 * __useCheckoutItemMutation__
 *
 * To run a mutation, you first call `useCheckoutItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutItemMutation, { data, loading, error }] = useCheckoutItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckoutItemMutation(baseOptions?: Apollo.MutationHookOptions<ICheckoutItemMutation, ICheckoutItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICheckoutItemMutation, ICheckoutItemMutationVariables>(CheckoutItemDocument, options);
      }
export type CheckoutItemMutationHookResult = ReturnType<typeof useCheckoutItemMutation>;
export type CheckoutItemMutationResult = Apollo.MutationResult<ICheckoutItemMutation>;
export type CheckoutItemMutationOptions = Apollo.BaseMutationOptions<ICheckoutItemMutation, ICheckoutItemMutationVariables>;
export const ReturnItemDocument = gql`
    mutation ReturnItem($data: ReturnItemInput!) {
  returnItem(data: $data) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;
export type IReturnItemMutationFn = Apollo.MutationFunction<IReturnItemMutation, IReturnItemMutationVariables>;

/**
 * __useReturnItemMutation__
 *
 * To run a mutation, you first call `useReturnItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnItemMutation, { data, loading, error }] = useReturnItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useReturnItemMutation(baseOptions?: Apollo.MutationHookOptions<IReturnItemMutation, IReturnItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IReturnItemMutation, IReturnItemMutationVariables>(ReturnItemDocument, options);
      }
export type ReturnItemMutationHookResult = ReturnType<typeof useReturnItemMutation>;
export type ReturnItemMutationResult = Apollo.MutationResult<IReturnItemMutation>;
export type ReturnItemMutationOptions = Apollo.BaseMutationOptions<IReturnItemMutation, IReturnItemMutationVariables>;
export const TransferItemLocationDocument = gql`
    mutation TransferItemLocation($data: TransferItemLocationInput!) {
  transferItemLocation(data: $data) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;
export type ITransferItemLocationMutationFn = Apollo.MutationFunction<ITransferItemLocationMutation, ITransferItemLocationMutationVariables>;

/**
 * __useTransferItemLocationMutation__
 *
 * To run a mutation, you first call `useTransferItemLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferItemLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferItemLocationMutation, { data, loading, error }] = useTransferItemLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransferItemLocationMutation(baseOptions?: Apollo.MutationHookOptions<ITransferItemLocationMutation, ITransferItemLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ITransferItemLocationMutation, ITransferItemLocationMutationVariables>(TransferItemLocationDocument, options);
      }
export type TransferItemLocationMutationHookResult = ReturnType<typeof useTransferItemLocationMutation>;
export type TransferItemLocationMutationResult = Apollo.MutationResult<ITransferItemLocationMutation>;
export type TransferItemLocationMutationOptions = Apollo.BaseMutationOptions<ITransferItemLocationMutation, ITransferItemLocationMutationVariables>;
export const TransferItemToPersonDocument = gql`
    mutation TransferItemToPerson($data: TransferItemToPersonInput!) {
  transferItemToPerson(data: $data) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;
export type ITransferItemToPersonMutationFn = Apollo.MutationFunction<ITransferItemToPersonMutation, ITransferItemToPersonMutationVariables>;

/**
 * __useTransferItemToPersonMutation__
 *
 * To run a mutation, you first call `useTransferItemToPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferItemToPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferItemToPersonMutation, { data, loading, error }] = useTransferItemToPersonMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransferItemToPersonMutation(baseOptions?: Apollo.MutationHookOptions<ITransferItemToPersonMutation, ITransferItemToPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ITransferItemToPersonMutation, ITransferItemToPersonMutationVariables>(TransferItemToPersonDocument, options);
      }
export type TransferItemToPersonMutationHookResult = ReturnType<typeof useTransferItemToPersonMutation>;
export type TransferItemToPersonMutationResult = Apollo.MutationResult<ITransferItemToPersonMutation>;
export type TransferItemToPersonMutationOptions = Apollo.BaseMutationOptions<ITransferItemToPersonMutation, ITransferItemToPersonMutationVariables>;
export const IntakeItemDocument = gql`
    mutation IntakeItem($data: IntakeItemInput!) {
  intakeItem(data: $data) {
    ...InventoryItemFragment
  }
}
    ${InventoryItemFragmentFragmentDoc}`;
export type IIntakeItemMutationFn = Apollo.MutationFunction<IIntakeItemMutation, IIntakeItemMutationVariables>;

/**
 * __useIntakeItemMutation__
 *
 * To run a mutation, you first call `useIntakeItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntakeItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [intakeItemMutation, { data, loading, error }] = useIntakeItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIntakeItemMutation(baseOptions?: Apollo.MutationHookOptions<IIntakeItemMutation, IIntakeItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IIntakeItemMutation, IIntakeItemMutationVariables>(IntakeItemDocument, options);
      }
export type IntakeItemMutationHookResult = ReturnType<typeof useIntakeItemMutation>;
export type IntakeItemMutationResult = Apollo.MutationResult<IIntakeItemMutation>;
export type IntakeItemMutationOptions = Apollo.BaseMutationOptions<IIntakeItemMutation, IIntakeItemMutationVariables>;